<!--
 * @Description: 
 * @Author: xuxiaofei
 * @Date: 2021-11-19 10:58:10
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @LastEditTime: 2022-09-01 15:09:34
-->
<template>
  <div class="dis-flex">
    <template v-if="imgList.length">
      <div v-for="(item, index) in imgList" :key="index" class="showImg">
        <img :src="item.url | imgHost" alt="" class="img" />
      </div>
    </template>
  </div>
</template>
        
<script>
/* eslint-disable */
export default {
	components: {
	},
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data () {		
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.dis-flex {
  // display: flex;
  // display: -webkit-flex;
}
.showImg {
  width: 80px;
  height: 80px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  // float: left;
  margin-right: 4px;
  >img {
    width: 100%;
    height: 100%;
    display: block;
  }
  &:hover {
    .removeImg {visibility: visible;}
  }
  .removeImg {
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 12px;
    visibility: hidden;
    line-height: 45px;
    i.iconfont {
      position: relative;
      top: 10px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
